//CRN_20260106 - SQL Injection Test "' or (select @@version) > 1 --"

import { _MiscMessages, AccessGuids, ApplicationNames, ConfigSystemParams, FlatpickrFormat, SelectorItemWidgetGroupKeyType, StorageValues, WidgetGroupKeys, WriteToTemplateDelay } from 'src/app/core/consts';
import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, NgZone, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { catchError, debounceTime, distinctUntilChanged, EMPTY, map, merge, Observable, Subject, Subscription, switchMap, take, takeUntil, throwError } from 'rxjs';
import { ChartConfigService } from 'src/app/core/services/utelize/general/chart-config-service';
import { ChartType } from './dashboard.model';
import { ComponentAccessUserService } from 'src/app/core/services/utelize/system/component-access/component-access-user-service';
import { ConfigSystemService } from 'src/app/core/services/utelize/system/config-system/config-system-service';
import { DashboardService } from 'src/app/core/services/utelize/general/dashboard-service';
import { DashboardUsersWithMostCostDTO } from 'src/app/core/models/system/dashboard/dashboard-users-with-most-cost.dto';
import { DatePipe } from '@angular/common';
import { DecryptAesClientSide, EncryptAesClientSide } from 'src/app/core/encryption';
import { DevicesAllocatedContentSharedComponent } from 'src/app/pages-content-shared/provisioning-content-shared/devices-allocated-content-shared/devices-allocated-content-shared.component';
import { DropdownService } from 'src/app/core/services/utelize/general/dropdown-service';
import { environment } from 'src/environments/environment';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { getSelectorItems_WidgetGroup, SelectorItemWidgetGroup } from 'src/app/core/interfaces/general/selector-item-widget-group';
import { OurDate } from 'src/app/core/interfaces/general/our-date';
import { PlatformInviewService } from 'src/app/core/services/utelize/general/platform-inview-service';
import { populateOurDate } from 'src/app/core/functions-generic/functions-generic-date';
import { StorageService } from 'src/app/core/services/utelize/general/storage-service';
import { SystemUserDTO } from 'src/app/core/models/system/user/system-user.dto';
import tippy, { Instance } from 'tippy.js';
import { TippyToolTipService } from 'src/app/core/services/utelize/general/tippy-tool-tip-service';
import { TopBarService } from 'src/app/core/services/utelize/general/top-bar-service';
import { WidgetRowAlertsComponent } from 'src/app/shared/widget-rows/widget-row-alerts/widget-row-alerts.component';
import { WidgetRowLicencesComponent } from 'src/app/shared/widget-rows/widget-row-licences/widget-row-licences.component';
import { WidgetRowTotalCostsComponent } from 'src/app/shared/widget-rows/widget-row-total-costs/widget-row-total-costs.component';
import { WidgetRowUsageComponent } from 'src/app/shared/widget-rows/widget-row-usage/widget-row-usage.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  providers: [TippyToolTipService]
})

export class DashboardComponent implements AfterViewInit, OnDestroy, OnInit {
  
  @ViewChild('bottomContainer',     { static: false }) bottomContainer!    : ElementRef<HTMLElement>;
  @ViewChild('devicesAllocated',    { static: false }) devicesAllocated!   : DevicesAllocatedContentSharedComponent;
  @ViewChild('widgetRowAlerts',     { static: false }) widgetRowAlerts!    : WidgetRowAlertsComponent;
  @ViewChild('widgetRowLicences',   { static: false }) widgetRowLicences!  : WidgetRowLicencesComponent;
  @ViewChild('widgetRowTotalCosts', { static: false }) widgetRowTotalCosts!: WidgetRowTotalCostsComponent;
  @ViewChild('widgetRowUsage',      { static: false }) widgetRowUsage!     : WidgetRowUsageComponent;
  
  @ViewChildren('railBtn', { read: ElementRef }) railBtns!: QueryList<ElementRef<HTMLButtonElement>>;

  get platformInviewMode() { return this.isPlatformModeInview ? this.platformInviewService.getMode() : null; }

  get companyTopLevelSelect() { return this.componentAccessUserService.hasAccessGuid(AccessGuids.DropdownsCompanyTopLevelSelect, true); }

  get widgetRowTitleAlerts    () { return this.configSystemService.getValue(ConfigSystemParams.WidgetRow_Title_Alerts,     _MiscMessages.TitleNotSet); }
  get widgetRowTitleLicences  () { return this.configSystemService.getValue(ConfigSystemParams.WidgetRow_Title_Licences,   _MiscMessages.TitleNotSet); }
  get widgetRowTitleTotalCosts() { return this.configSystemService.getValue(ConfigSystemParams.WidgetRow_Title_TotalCosts, _MiscMessages.TitleNotSet); }

  get activityEnabled             () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.DashboardActivityEnabled,              false  ); }
  get allowContainerClose         () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.DashboardContainerCloseAllow,          true   ); }
  get changeTitles                () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.DashboardChangeTitles,                 true   ); }
  get interactiveUserGrid         () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.DashboardGridUserInteractiveEnabled,   false  ); }
  get showActivityOnStart         () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.DashboardShowActivityOnStart,          false  ); }
  get showCompanyForUser          () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.DashboardShowCompanyForUser,           false  ) &&
                                              !this.componentAccessUserService.hasAccessGuid(AccessGuids.DashboardShowCompanyForUserGuard,         true   ); }
  get showCostsPerZone            () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.DashboardShowCostsPerZone,             false  ); }
  get showCostsPerZoneIfNoData    () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.DashboardShowCostsPerZoneIfNoData,     true   ); }
  get showDateSelector            () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.DashboardShowDateSelector,             false  ); }
  get showDateSelectorViaIconClick() { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.DashboardShowDateSelectorViaIconClick, false  ); }
  get showPageHeader              () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.DashboardShowPageHeader,               true   ); }
  get showSubTitle                () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.DashboardShowSubTitle,                 true   ); }
  get showTemplateMenuItems       () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.ShowTemplateMenuItems,                 false  ); }
  get showTitle                   () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.DashboardShowTitle,                    true   ); }
  get showWidgetStepSelector      () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.DashboardShowWidgetStepSelector,       true   ); }
  get showWidgetTotalCompanies    () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.DashboardShowWidgetTotalCompanies,     true   ); }
  get superHierarchyEnabled       () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.DropdownCompanySuperHierarchyEnabled,  false  ); }
  get sureSimLogoGrow             () { return false;
                                       return this.configSystemService.getValueAsBoolean(ConfigSystemParams.SureSimLogoGrow,                       false  ) &&
                                              !this.componentAccessUserService.hasAccessGuid(AccessGuids.AnimationSureSimLogoGrowGuard,            true   ); }
  get testMode                    () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.SystemTestMode,                        false  ); }
  get titlesEmbedCompanyDropDown  () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.PagesTitlesEmbedCompanyDropDown,       true   ); }
  get titlesEmbedDateDropDown     () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.PagesTitlesEmbedDateDropDown,          true   ); }
  get titlesUseSureSimBlue        () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.PagesTitlesUseSureSimBlue,             false  ); }
  
  get changeTitleDelay  () { return this.configSystemService.getValueAsInteger(ConfigSystemParams.DashboardChangeTitleDelay, WriteToTemplateDelay.FiveMins); }
  get donut0DynamicWidth() { return String(    this.configSystemService.getValueAsInteger(ConfigSystemParams.DashboardDonutCostsPerZoneWidth, 30 ))+"%"    ; }
  get grid0DynamicWidth () { return String(100-this.configSystemService.getValueAsInteger(ConfigSystemParams.DashboardDonutCostsPerZoneWidth, 30 ))+"%"    ; }

  private bottomContainerObserver   : ResizeObserver | undefined;
  private companyDropdownReported   : boolean=false;
  private subscriptionCompany!      : Subscription;
  private subscriptionInviewMode    : Subscription | undefined;
  private subscriptionSim!          : Subscription;
  private subscriptionUser!         : Subscription;
  private widgetStepSelectorTooltips: Instance[]=[];

  private destroy$  =new Subject<void>();
  private selection$=new Subject<{ companyId: number; date: { year: number; month: number; day: number } }>();

  public _showDateSelector           : boolean=false;
  public analyticsChart!             : ChartType;
  public bestSelling                 : any;
  public breadCrumbItems!            : Array<{}>;
  public costsPerZoneChart!          : ChartType;
  public costsPerZoneTotalCosts      : number[]=[];
  public currentDate                 : any;
  public curUser                     : SystemUserDTO;
  public dropdownReady               : boolean=false;
  public extendView                  : boolean=false;
  public filterCompanyID             : number | undefined;
  public filterDate                  : OurDate | undefined=populateOurDate(this.exceptionsService, Date.now());
  public filterDateFormat            : string=FlatpickrFormat.MonthWordFull_Year;
  public headerClass                 : string="modal-header bg-light p-3";
  public headerTitle                 : string="Dashboard";
  public interactiveUserGridShow     : boolean=false;
  public isPlatformModeInview        : boolean=environment.platformModeInview;
  public loadingChart                : boolean=true;
  public loadingUsersWithMostCost    : boolean=true;
  public recentelling                : any;
  public salesCategoryChart!         : ChartType;
  public selectedWidgetGroupIndex    : number=0;
  public statData!                   : any;
  public subTitle!                   : string;
  public title!                      : string;
  public today                       : string | null=this.datePipe.transform(new Date(Date.now()), 'dd/MM/yyyy HH:mm:ss')
  public topSelling                  : any;
  public userWithMostCost            : DashboardUsersWithMostCostDTO[] | undefined;
  public widgetsExpanded             : boolean=false;
  
  constructor(
    private authenticationService     : AuthenticationService,
    private changeDetectorRef         : ChangeDetectorRef,
    private chartConfigService        : ChartConfigService,
    private componentAccessUserService: ComponentAccessUserService,
    private configSystemService       : ConfigSystemService,
    private dashboardService          : DashboardService,
    private datePipe                  : DatePipe,
    private dropdownService           : DropdownService,
    private exceptionsService         : ExceptionsService,
    private ngZone                    : NgZone,
    private platformInviewService     : PlatformInviewService,
    private storageService            : StorageService,
    private tippyToolTipService       : TippyToolTipService,
    private topBarService             : TopBarService
  ) {
    var date            =new Date();
    var firstDay        =new Date(date.getFullYear(), date.getMonth(), 1);
    var lastDay         =new Date(date.getFullYear(), date.getMonth() + 1, 0);
    this.currentDate    ={ from: firstDay, to: lastDay };
    this.curUser        =this.authenticationService.currentUserObject();
    this.filterCompanyID=this.dropdownService.trackerCompanyId ?? (this.companyTopLevelSelect ? 0-this.curUser.companyId : this.curUser.companyId);
  }

  public ngOnInit(): void {
    try {
      this.breadCrumbItems = [
        { label: 'Dashboards' },
        { label: 'Dashboard', active: true }
      ];

      this.widgetsExpanded=false;
      
      this.setTitle();
      this.setActivityPanel();

      if (!(this.isPlatformModeInview && this.platformInviewService.getMode()==='platform'))
        this.topBarService.showAdd_Company_SimProv_SupportTicket_UserPortal_UserSim();

      this.setSubscriptions();
      this.initSelectionStream();

      //CRN_20260407 - Trigger change detection when platform mode changes
      
      if (this.isPlatformModeInview) {
        this.subscriptionInviewMode=this.platformInviewService.mode().subscribe(() => {
          this.changeDetectorRef.detectChanges();
        });
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ngAfterViewInit(): void {
    try {
      this.setupWidgetExpandCollapseTooltips();
      this.setupWidgetStepSelectorTooltips();
      this.interactiveUserGridShow=false;

      this.railBtns.changes?.subscribe(() => this.setupWidgetStepSelectorTooltips());
      
      //CRN_20250926 - Retain for future use
      //this.clientInfoService.viewport$.subscribe(v => this.viewport = v);

      setTimeout(() => {
        this.dropdownReady=true;
      });

      setTimeout(() => {
        if (!this.companyDropdownReported) {
          this.emitCompanyAndDateFiltersToWidgetRow();
          this.emitSelection();
        }
      }, 2000);

      this.updateTableMaxHeight();
      this.bottomContainerObserver=new ResizeObserver(() => this.updateTableMaxHeight());

      if (this.bottomContainer?.nativeElement)
        this.bottomContainerObserver.observe(this.bottomContainer.nativeElement);

      window.addEventListener('resize', this.updateTableMaxHeight.bind(this));
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ngOnDestroy(): void {
    try {
      this.bottomContainerObserver?.disconnect();
      window.removeEventListener('resize', this.updateTableMaxHeight.bind(this));
      this.subscriptionInviewMode?.unsubscribe();
      this.topBarService.hideAdd_Company_SimProv_SupportTicket_UserPortal_UserSim();
      this.freeSubscriptions();
      this.destroy$.next();
      this.destroy$.complete();
      this.disposeRailTooltips();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private updateTableMaxHeight(): void {
    try {
      if (!this.bottomContainer?.nativeElement)
        return;

      if (this.extendView) {
        document.documentElement.style.removeProperty('--users-most-cost-max-height');
        return;
      }

      const footerHeight  =60;
      const titleRowHeight=52;
      const cardPadding   =16;
      const gap           =16;
      const containerTop  =this.bottomContainer.nativeElement.getBoundingClientRect().top;
      const maxHeight     =window.innerHeight - containerTop - titleRowHeight - cardPadding - footerHeight - gap;
      document.documentElement.style.setProperty('--users-most-cost-max-height', `${maxHeight}px`);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private disposeRailTooltips(): void {
    try {
      this.widgetStepSelectorTooltips.forEach(t => t.destroy());
      this.widgetStepSelectorTooltips=[];
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public setupWidgetExpandCollapseTooltips() {
    try {
      this.tippyToolTipService.setupBootstrapTooltips('[data-bs-toggle="tooltip"]', 'left');
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public setupWidgetStepSelectorTooltips() {
    try {
      this.disposeRailTooltips()
    
      setTimeout(() => {
        this.railBtns.forEach(ref => {
          const element=ref.nativeElement;
          const tooltip=tippy(element, {
            appendTo   : () => document.body,
            content    : "",
            hideOnClick: false,
            placement  : "left",
            theme      : "ss-blue",
            trigger    : "mouseenter focus",
            onShow(instance) {
              const element=instance.reference as HTMLElement;
              const newText=element.getAttribute("data-bs-title") ?? "";
              instance.setContent(newText);
            }
          });
          this.widgetStepSelectorTooltips.push(...(Array.isArray(tooltip) ? tooltip : [tooltip]));
        });
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#region Subscriptions

  public setSubscriptions(): void {
    try {
      this.subscriptionCompany=this.topBarService.savedCompany$
      .subscribe(sureSimCompanyId => {
        this.companyDataHasBeenSaved(sureSimCompanyId);
      });
      
      this.subscriptionSim=this.topBarService.savedSim$
      .subscribe(x => {
        this.iccidHasBeenProvisioned();
      });
      
      this.subscriptionUser=this.topBarService.savedUser$
      .subscribe(sureSimUserId => {
        this.userDataHasBeenSaved(sureSimUserId);
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public companyDataHasBeenSaved(sureSimCompanyId: number | undefined) {
    try {
      this.companyDropDownOnChange(this.filterCompanyID ?? -1);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public iccidHasBeenProvisioned() {
    try {
      
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public userDataHasBeenSaved(sureSimUserId: number | undefined) {
    try {

    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public freeSubscriptions(): void {
    try {
      this.subscriptionCompany.unsubscribe();
      this.subscriptionSim.unsubscribe();
      this.subscriptionUser.unsubscribe();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  public setTitle(): void {
    try {
      if (DecryptAesClientSide(this.storageService.getItem(StorageValues.encLoginTitleSet))) {
        this.setLoginTitle();

      } else {
        this.title   =`Hello ${this.designation()}`;
        this.subTitle=`Welcome to ${!this.isPlatformModeInview || this.platformInviewMode !== 'platform'
                                    ? ApplicationNames.SureSIM
                                    : 'the ' + ApplicationNames.InviewPortal}`;
    
        if (this.changeTitles) {
          setTimeout(() => {
            this.setLoginTitle();
          }, this.changeTitleDelay);
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public setLoginTitle(): void {
    try {
      this.title   =this.designation();
      let lastLogin=new Date(<Date>this.curUser.lastLogin);

      if (lastLogin.getFullYear()<2000) {
        this.subTitle=`Statistics at a glance`;

      } else {
        this.subTitle=`Last login - ${this.datePipe.transform(lastLogin, 'EEEE dd/MM/yyyy HH:mm:ss')}`;
      }

      this.storageService.setItem(StorageValues.encLoginTitleSet, EncryptAesClientSide('true'));
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private designation(): string {
    try {
      return `${this.curUser.firstname} ${this.curUser.lastname} ${this.showCompanyForUser ? " - " + this.curUser.companyName: ""}`;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return "Unknown Designation";
    }
  }

  public setActivityPanel(): void {
    try {
      if (!this.activityEnabled || !this.showActivityOnStart) {
        this.toggleActivity();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public toggleActivity() {
    try {
      const recentActivity=document.querySelector('.layout-rightside-col');

      if (recentActivity != null) {
        recentActivity.classList.toggle('d-none');
      }
  
      // if (this.activityEnabled && document.documentElement.clientWidth <= 767) {
      //   const recentActivity=document.querySelector('.layout-rightside-col');
        
      //   if (recentActivity != null) {
      //     recentActivity.classList.add('d-block');
      //     recentActivity.classList.remove('d-none');
      //   }
      // }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public SidebarHide() {
    try {
      const recentActivity=document.querySelector('.layout-rightside-col');

      if (recentActivity != null) {
        recentActivity.classList.remove('d-block');
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public showDateSelectorClick() {
    try {
      this._showDateSelector=true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public companyDropDownOnChange(companyID: number) {
    try {
      this.filterCompanyID=!this.superHierarchyEnabled &&
                           (companyID==null ||
                            companyID==undefined ||
                            companyID<=0)
                           ?
                           0 - this.curUser.companyId
                           :
                           companyID;

      this.companyDropdownReported         =true;
      this.dropdownService.trackerCompanyId=this.filterCompanyID;

      this.emitCompanyAndDateFiltersToWidgetRow();
      this.emitSelection();

      if (this.devicesAllocated && this.interactiveUserGrid)
        this.devicesAllocated.companyDropDownOnChange(companyID);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
       return (undefined);
    }
  }

  public dateFilterChanged(selectedDate: OurDate) {
    try {
      this.filterDate=selectedDate;
      this.emitCompanyAndDateFiltersToWidgetRow();
      this.emitSelection();

      if (this.devicesAllocated && this.interactiveUserGrid)
        this.devicesAllocated.dateFilterChanged(selectedDate);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#region Charts
  
  public refreshUserWithMostCost() {
    try {
      this.loadingUsersWithMostCost=true;
      
      this.dashboardService.getUserWithMostCost(
        this.filterCompanyID            ?? -1,
        <number>(this.filterDate?.year  ?? 1),
        <number>(this.filterDate?.month ?? 1),
        <number>(this.filterDate?.day   ?? 1)
      )
      .pipe(
        catchError((error) => {
          this.loadingUsersWithMostCost=false;
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.applyUsersWithMostCost(data);
          this.changeDetectorRef.markForCheck();
        },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#region Charts chartsVersion20251023

  //#region initSelectionStream
  
  private initSelectionStream(): void {
    try {
      this.selection$
      .pipe(
        debounceTime(150),
        distinctUntilChanged((a, b) =>
          a.companyId ===b.companyId  &&
          a.date.year ===b.date.year  &&
          a.date.month===b.date.month &&
          a.date.day  ===b.date.day
        ),
        switchMap(selected => {
          const companyId=selected.companyId;
          const year     =selected.date.year;
          const month    =selected.date.month;
          const day      =selected.date.day;

          this.loadingChart            =true;
          this.loadingUsersWithMostCost=true;

          const safeTile=<T>(observable: Observable<T>, applyFn: (data: T) => void) =>
            observable.pipe(
              catchError(err => {
                this.exceptionsService.handleException(new Error(this.exceptionsService.formatHttpError(err)));
                return EMPTY;
              }),
              map(data => { applyFn(data); })
            );

          return merge(
            safeTile(this.dashboardService.getCostsPerZone    (companyId, year, month, day), d => this.applyCostsPerZone     (d)),
            safeTile(this.dashboardService.getUserWithMostCost(companyId, year, month, day), d => this.applyUsersWithMostCost(d))
          );
        }),
        takeUntil(this.destroy$)
      )
      .subscribe(() => {
        this.changeDetectorRef.markForCheck();
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  private emitSelection(): void {
    try {
      const companyId=this.filterCompanyID ?? -1;
      const date     ={
        year : <number>(this.filterDate?.year  ?? 1),
        month: <number>(this.filterDate?.month ?? 1),
        day  : <number>(this.filterDate?.day   ?? 1),
      };
      
      this.selection$.next({ companyId, date });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private applyCostsPerZone(data: Array<{ totalCost: number; zoneAlias: string }>) {
    try {
      this.loadingChart          =false;
      this.costsPerZoneTotalCosts=[];
      let zones: any             =[];
  
      for (let zoneData of data) {
        this.costsPerZoneTotalCosts.push(zoneData.totalCost);
        zones.push(zoneData.zoneAlias);
      }
  
      let colors: any=this.chartConfigService.resolveColours(this.chartConfigService.defaultColoursArray);
      
      this.costsPerZoneChart = {
        series: this.costsPerZoneTotalCosts,
        labels: zones,
        chart : {
          height: 333,
          type: "donut",
        },
        colors    : colors,
        dataLabels: {
          dropShadow: {
            enabled: false,
          },
        },
        legend: {
          position: "bottom",
        },
        stroke: {
          show: false
        },
        tooltip: {
          enabled: true,
          x: {
            show: false,
          },
          y: {
            show: true,
            formatter: (value: number) => `£${value}`
          }
        }
      };
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private applyUsersWithMostCost(data: DashboardUsersWithMostCostDTO[]) {
    try {
      this.loadingUsersWithMostCost=false;
      this.userWithMostCost        =data;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  public extendViewCheckboxChange(): void {
    try {
      setTimeout(() => {
        if (this.interactiveUserGridShow) {
          if (this.extendView)
            this.devicesAllocated?.gridView?.dataGrid?.instance?.option('height', 'auto');
          else
            this.devicesAllocated?.gridView?.applyStickyGridPager();
        } else {
          this.updateTableMaxHeight();
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public interactiveGridCheckboxChange() {
    try {
      setTimeout(() => {
        if (this.interactiveUserGridShow) {
          if (this.extendView)
            this.devicesAllocated?.gridView?.dataGrid?.instance?.option('height', 'auto');
          else
            this.devicesAllocated?.gridView?.applyStickyGridPager();
        } else {
          this.updateTableMaxHeight();
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public widgetExpandCollapseClick() {
    try {
      this.widgetsExpanded=!this.widgetsExpanded;
        
      this.changeDetectorRef.detectChanges();
      
      this.ngZone.onStable.pipe(take(1)).subscribe(() => {
        this.emitCompanyAndDateFiltersToWidgetRow();
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#region Widget Group Selector

  public get selectedWidgetGroup         (): SelectorItemWidgetGroup        { return getSelectorItems_WidgetGroup(this.configSystemService)[this.selectedWidgetGroupIndex]        ; }
  public get selectedWidgetGroupKey      (): SelectorItemWidgetGroupKeyType { return this.selectedWidgetGroup.key                                                                 ; }
  public get widgetGroupSelectorCanDown  (): boolean                        { return this.selectedWidgetGroupIndex<getSelectorItems_WidgetGroup(this.configSystemService).length-1; }
  public get widgetGroupSelectorCanUp    (): boolean                        { return this.selectedWidgetGroupIndex>0                                                              ; }
  
  public get selectedWidgetGroupNextLabel(): string | null { return this.widgetGroupSelectorCanDown ? getSelectorItems_WidgetGroup(this.configSystemService)[this.selectedWidgetGroupIndex+1].label : null; }
  public get selectedWidgetGroupPrevLabel(): string | null { return this.widgetGroupSelectorCanUp   ? getSelectorItems_WidgetGroup(this.configSystemService)[this.selectedWidgetGroupIndex-1].label : null; }

  public onWidgetGroupSelectorUp() {
    try {
      if (this.widgetGroupSelectorCanUp) {
        this.selectedWidgetGroupIndex--;
        
        this.changeDetectorRef.detectChanges();

        this.ngZone.onStable.pipe(take(1)).subscribe(() => {
          this.emitCompanyAndDateFiltersToWidgetRow();
        });
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onWidgetGroupSelectorDown() {
    try {
      if (this.widgetGroupSelectorCanDown) {
        this.selectedWidgetGroupIndex++;
        
        this.changeDetectorRef.detectChanges();

        this.ngZone.onStable.pipe(take(1)).subscribe(() => {
          this.emitCompanyAndDateFiltersToWidgetRow();
        });
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public emitCompanyAndDateFiltersToWidgetRow() {
    try {
      if (this.widgetsExpanded) {
        this.widgetRowAlerts    ?.emitSelection(this.filterCompanyID, this.filterDate);
        this.widgetRowLicences  ?.emitSelection(this.filterCompanyID, this.filterDate);
        this.widgetRowTotalCosts?.emitSelection(this.filterCompanyID, this.filterDate);
        this.widgetRowUsage     ?.emitSelection(this.filterCompanyID, this.filterDate);

      } else {
        switch (this.selectedWidgetGroup.key) {
                  
          case WidgetGroupKeys.totalAlerts:
            this.widgetRowAlerts?.emitSelection(this.filterCompanyID, this.filterDate);
            break;
                  
          case WidgetGroupKeys.totalCosts:
            this.widgetRowTotalCosts?.emitSelection(this.filterCompanyID, this.filterDate);
            break;
          
          case WidgetGroupKeys.totalLicences:
            this.widgetRowLicences?.emitSelection(this.filterCompanyID, this.filterDate);
            break;
          
          case WidgetGroupKeys.totalSimsUsageCosts:
            this.widgetRowUsage?.emitSelection(this.filterCompanyID, this.filterDate);
            break;
          
          default:
            break;
          
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Testing - CRN_20260513 - Keep at bottom for ease finding

  //CRN_20251126 - Do not remove this method, it is used.
  //               Ensure contents are commented out after use.

  public testIconClick() {
    try {
      //CRN_20251201 - SQL Injection Test "' or (select @@version) > 1 --"
      //             - Example: this.licencesCompanyAllocatedService.companyHasLicenceFeatureByGuid(this.curUser.companyId, "' or (select @@version) > 1 --")

      // const x: EsimReservationDTO={
      //            deviceId        : 123,
      //            deviceTypeId    : 123,
      //            iccid           : "xxx",
      //            inviewCompanyId : 123,
      //            numberToReserve : 123,
      //            orderGuid       : "xxx",
      //          }

      //CRN_20230123 - Standard data call
      // this.webbingService.SetProduct("123456789", 12345)//, 123)//, <OurDate>populateOurDate(this.exceptionsService, "01/01/2050"), <OurDate>populateOurDate(this.exceptionsService, "01/01/2050"))//, 1324)//, 33333, 44444)//, undefined)
      // .pipe(
      //   catchError((error) => {
      //     return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
      //   })
      // )
      // .subscribe({
      //   next: data => {
      //     const _data=data;
      //   },
      //   error: error => {
      //     this.exceptionsService.handleException(new Error(error));
      //   }
      // });
      
      //CRN_20250915 - BooleanResult
      // this.teamsMetaService.getCallsForYesterday()//(77, 251, [2,4,8,16])
      // .pipe(
      //   catchError((error) => {
      //     return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
      //   })
      // )
      // .subscribe({
      //   next: data => {
      //     const x=data.result;
      //   },
      //   error: error => {
      //     this.exceptionsService.handleException(new Error(error));
      //   }
      // });
      
      //CRN_20250919 - IntegerResult
      //this.devicesService.totalLiveDevicesForCompany(77)
      // this.licencesCompanyAllocatedService.totalLivePlatformLicencesForCompany(77)
      // .pipe(
      //   catchError((error) => {
      //     return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
      //   })
      // )
      // .subscribe({
      //   next: data => {
      //     const x=data.result;
      //   },
      //   error: error => {
      //     this.exceptionsService.handleException(new Error(error));
      //   }
      // });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion
}
